<template>
  <!-- eslint-disable -->
<svg class="fertility-state-pregnant-solid-crv crv-svg-icon"  xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
    <path fill-rule="evenodd" d="M11,2 C15.9705627,2 20,6.02943725 20,11 C20,15.9705627 15.9705627,20 11,20 C6.02943725,20 2,15.9705627 2,11 C2,6.02943725 6.02943725,2 11,2 Z M11,5 C7.6862915,5 5,7.6862915 5,11 C5,14.3137085 7.6862915,17 11,17 L11.024,16.999 L11.0241961,5.00004776 C11.0161345,5.00001593 11.0080691,5 11,5 Z"/>
  </svg>
<!-- eslint-enable -->
</template>